import { render, staticRenderFns } from "./TestatorAssistanceGuide.vue?vue&type=template&id=cab020ba"
import script from "./TestatorAssistanceGuide.vue?vue&type=script&lang=js"
export * from "./TestatorAssistanceGuide.vue?vue&type=script&lang=js"
import style0 from "./TestatorAssistanceGuide.vue?vue&type=style&index=0&id=cab020ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports